// src/hooks/usePlatform.js
// Shares one computed platform snapshot app-wide via context, instead of every
// consumer re-running UA/matchMedia checks. Display mode doesn't change at
// runtime, so this is computed once per session.
import React, { createContext, useContext, useMemo } from 'react';
import { isAndroid, isIOS, isTWA, isStandaloneDisplayMode } from '../utils/platform';

const PlatformContext = createContext(null);

function computePlatform() {
  const standalone = isStandaloneDisplayMode() || isTWA();
  return {
    isStandaloneApp: standalone,
    isTWA: isTWA(),
    os: isAndroid() ? 'android' : isIOS() ? 'ios' : 'web',
  };
}

export function PlatformProvider({ children }) {
  const value = useMemo(() => computePlatform(), []);
  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>;
}

export function usePlatform() {
  const ctx = useContext(PlatformContext);
  if (!ctx) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return ctx;
}
